import React from "react";
import useDayCalendar from "../../hooks/calendar/useDayCalendar";
import "./calendar.css";
const addOverlapColumns = (appointments, unavailables) => {
  const events = [
    ...appointments.map((appointment) => ({
      ...appointment,
      type: "appointment",
    })),

    ...unavailables.map((unavailable) => ({
      ...unavailable,
      type: "unavailable",
    })),
  ];
  const sorted = [...events].sort((a, b) =>
    a.startTime.localeCompare(b.startTime),
  );

  const groups = [];
  const result = [];

  sorted.forEach((app) => {
    let group = groups.find((g) =>
      g.some(
        (item) => app.startTime < item.endTime && app.endTime > item.startTime,
      ),
    );

    if (!group) {
      group = [];
      groups.push(group);
    }

    group.push(app);
  });

  groups.forEach((group) => {
    const totalColumns = group.length > 1 ? group.length : 1;

    group.forEach((app, index) => {
      result.push({
        ...app,
        column: index,
        totalColumns,
      });
    });
  });

  return result;
};
const DayView = ({
  date,
  employee,
  appointments = [],
  employeeColors = [],
  unavailableEmployees = [],
  showModalShortcut,
}) => {
  const { timeSlots, getTop, getHeight, isToday } = useDayCalendar();
  const getEmployeeColor = (name) => {
    return (
      employeeColors.find((item) => item.name === name)?.color || "#849b8c"
    );
  };
  return (
    <div className="day-calendar">
      <div className="calendar-header border-bottom  fw-bold d-flex justify-content-center"></div>

      <div className="calendar-body">
        {/* Time column */}

        <div className="time-column">
          {timeSlots.map((slot) => (
            <div key={slot} className="time-slot">
              {slot}
            </div>
          ))}
        </div>

        {/* Schedule */}

        <div className="schedule-column">
          {timeSlots.map((slot) => (
            <div
              key={slot}
              className={`schedule-slot ${isToday(date) ? "today" : ""}`}
              onClick={() => showModalShortcut(date, slot)}
            />
          ))}

          {addOverlapColumns(appointments, unavailableEmployees).map(
            (event) => {
              if (event.type == "appointment") {
                return (
                  <div
                    key={event.id}
                    className="appointment"
                    style={{
                      top: getTop(event.startTime),
                      height: getHeight(event.startTime, event.endTime),
                      left: `${(event.column * 100) / event.totalColumns}%`,
                      width: `${100 / event.totalColumns - 1}%`,
                      backgroundColor: getEmployeeColor(event.staffName),
                    }}
                  >
                    <div className="appointment-main">
                      <strong>
                        {event.client} ·{" "}
                        {event.services
                          .map((service) => service.name)
                          .join(", ")}
                      </strong>
                    </div>

                    <div className="appointment-staff">{event.staffName}</div>
                  </div>
                );
              } else {
                return (
                  <div
                    key={event.id}
                    className="unavailable-event"
                    style={{
                      top: getTop(event.startTime),
                      height: getHeight(event.startTime, event.endTime),
                      left: `${(event.column * 100) / event.totalColumns}%`,
                      width: `${100 / event.totalColumns - 1}%`,
                      backgroundColor: "#f8d7da",
                    }}
                  >
                    <div className="appointment-main">
                      <strong>{event.barber} - unavailable</strong>
                    </div>

                    <div className="appointment-staff">{event.staffName}</div>
                  </div>
                );
              }
            },
          )}
        </div>
      </div>
    </div>
  );
};

export default DayView;
